<template>
  <div id="reset_password_modal" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Reset Password - {{ employeeName }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="closeBtn">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="resetPassword">
            <div class="input-block mb-3">
              <label class="col-form-label">New Password <span class="text-danger">*</span></label>
              <div class="pass-group">
                <input
                  :type="passwordVisible ? 'text' : 'password'"
                  class="form-control"
                  :class="{ 'is-invalid': password && password.length < 6 }"
                  v-model="password"
                  required
                  minlength="6"
                />
                <span
                  :class="['fa-solid', passwordVisible ? 'fa-eye' : 'fa-eye-slash', 'toggle-password']"
                  @click="passwordVisible = !passwordVisible"
                ></span>
                <div v-if="password && password.length < 6" class="invalid-feedback">
                  Password must be at least 6 characters.
                </div>
              </div>
            </div>
            <div class="input-block mb-3">
              <label class="col-form-label">Confirm Password <span class="text-danger">*</span></label>
              <div class="pass-group">
                <input
                  :type="confirmPasswordVisible ? 'text' : 'password'"
                  class="form-control"
                  :class="{ 'is-invalid': confirmPassword && password !== confirmPassword }"
                  v-model="confirmPassword"
                  required
                  minlength="6"
                />
                <span
                  :class="['fa-solid', confirmPasswordVisible ? 'fa-eye' : 'fa-eye-slash', 'toggle-password']"
                  @click="confirmPasswordVisible = !confirmPasswordVisible"
                ></span>
                <div v-if="confirmPassword && password !== confirmPassword" class="invalid-feedback">
                  Passwords do not match.
                </div>
              </div>
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn" type="submit" :disabled="loading || !isFormValid">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                Reset Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../../config";

export default {
  name: "ResetPasswordModal",
  data() {
    return {
      userId: null,
      employeeName: "",
      password: "",
      confirmPassword: "",
      passwordVisible: false,
      confirmPasswordVisible: false,
      loading: false,
    };
  },
  computed: {
    isFormValid() {
      return this.password && this.password.length >= 6 && this.password === this.confirmPassword;
    }
  },
  methods: {
    updateValues(employee) {
      this.userId = employee.id || employee.user_id;
      this.employeeName = employee.name || `${employee.first_name} ${employee.last_name}`;
      this.password = "";
      this.confirmPassword = "";
      this.passwordVisible = false;
      this.confirmPasswordVisible = false;
    },
    async resetPassword() {
      if (!this.isFormValid) {
        return;
      }

      this.loading = true;
      try {
        const response = await axios.post(`${VUE_APP_API_BASE_URL}/user/reset-password`, {
          user_id: this.userId,
          password: this.password,
        });

        if (response.data.status) {
          this.$toast.success(response.data.message || "Password reset successfully");
          this.$refs.closeBtn.click();
        } else {
          let errorMsg = "Failed to reset password";
          if (response.data.errors) {
            if (typeof response.data.errors === 'string') {
              errorMsg = response.data.errors;
            } else if (typeof response.data.errors === 'object') {
              errorMsg = Object.values(response.data.errors).flat().join(', ');
            }
          } else if (response.data.message) {
            errorMsg = response.data.message;
          }
          this.$toast.error(errorMsg);
        }
      } catch (error) {
        console.error(error);
        const errorMsg = error.response?.data?.message || error.response?.data?.errors || "Something went wrong";
        this.$toast.error(typeof errorMsg === 'object' ? Object.values(errorMsg).flat().join(', ') : errorMsg);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.toggle-password {
  float: right;
  margin-left: -30px;
  margin-top: -25px;
  position: relative;
  z-index: 2;
  cursor: pointer;
  padding-right: 10px;
}
.invalid-feedback {
  display: block;
}
</style>
